module.exports = __webpack_public_path__ + "static/media/shadow-covered.a808e5df.svg";